import { render, staticRenderFns } from "./MonacoEditorBase.vue?vue&type=template&id=d5405286&scoped=true"
import script from "./MonacoEditorBase.vue?vue&type=script&lang=js"
export * from "./MonacoEditorBase.vue?vue&type=script&lang=js"
import style0 from "./MonacoEditorBase.vue?vue&type=style&index=0&id=d5405286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5405286",
  null
  
)

export default component.exports